export default __webpack_public_path__ + "static/avatar-kortical-team3--mobile-eda28f7be81267d38a8242221093c9ec.webp";